import { createAsyncThunk } from '@reduxjs/toolkit';
import MonetizationAPI from './monetizationAPI';

export const fetchMonetizationConfigThunk = createAsyncThunk(
  'monetization/fetchConfig',
  async (_, { rejectWithValue }) => {
    try {
      return await MonetizationAPI.fetchConfig();
    } catch (err) {
      return rejectWithValue(err.message || 'Failed to fetch monetization config');
    }
  }
);

export const onboardConnectThunk = createAsyncThunk(
  'monetization/onboardConnect',
  async (_, { rejectWithValue }) => {
    try {
      const { onboarding_url } = await MonetizationAPI.onboardConnect();
      // Full external redirect -- Stripe's own hosted onboarding, not a
      // React Router route -- same window.location idiom already used for
      // other external-provider redirects in this codebase.
      window.location.assign(onboarding_url);
      return { onboarding_url };
    } catch (err) {
      return rejectWithValue(err.response?.data?.error?.message || err.message || 'Failed to start onboarding');
    }
  }
);

export const fetchConnectStatusThunk = createAsyncThunk(
  'monetization/fetchConnectStatus',
  async (_, { rejectWithValue }) => {
    try {
      return await MonetizationAPI.fetchConnectStatus();
    } catch (err) {
      return rejectWithValue(err.message || 'Failed to fetch connect status');
    }
  }
);

export const fetchGroupPricingThunk = createAsyncThunk(
  'monetization/fetchGroupPricing',
  async (groupId, { rejectWithValue }) => {
    try {
      const data = await MonetizationAPI.fetchGroupPricing(groupId);
      return { groupId, data };
    } catch (err) {
      return rejectWithValue(err.message || 'Failed to fetch group pricing');
    }
  }
);

export const setGroupPricingThunk = createAsyncThunk(
  'monetization/setGroupPricing',
  async ({ groupId, pricing }, { rejectWithValue }) => {
    try {
      const data = await MonetizationAPI.setGroupPricing(groupId, pricing);
      return { groupId, data };
    } catch (err) {
      return rejectWithValue(err.response?.data?.error?.message || err.message || 'Failed to update pricing');
    }
  }
);

export const subscribeToGroupThunk = createAsyncThunk(
  'monetization/subscribeToGroup',
  async (groupId, { rejectWithValue }) => {
    try {
      const { checkout_url } = await MonetizationAPI.subscribeToGroup(groupId);
      window.location.assign(checkout_url);
      return { checkout_url };
    } catch (err) {
      return rejectWithValue(err.response?.data?.error?.message || err.message || 'Failed to start checkout');
    }
  }
);

export const fetchMySubscriptionThunk = createAsyncThunk(
  'monetization/fetchMySubscription',
  async (groupId, { rejectWithValue }) => {
    try {
      const data = await MonetizationAPI.fetchMySubscription(groupId);
      return { groupId, data };
    } catch (err) {
      return rejectWithValue(err.message || 'Failed to fetch subscription');
    }
  }
);

export const cancelSubscriptionThunk = createAsyncThunk(
  'monetization/cancelSubscription',
  async (groupId, { rejectWithValue }) => {
    try {
      await MonetizationAPI.cancelSubscription(groupId);
      return { groupId };
    } catch (err) {
      return rejectWithValue(err.response?.data?.error?.message || err.message || 'Failed to cancel subscription');
    }
  }
);

export const fetchMySubscriptionsThunk = createAsyncThunk(
  'monetization/fetchMySubscriptions',
  async (_, { rejectWithValue }) => {
    try {
      return await MonetizationAPI.fetchMySubscriptions();
    } catch (err) {
      return rejectWithValue(err.message || 'Failed to fetch your subscriptions');
    }
  }
);

export const fetchEarningsThunk = createAsyncThunk(
  'monetization/fetchEarnings',
  async (userId, { rejectWithValue }) => {
    try {
      return await MonetizationAPI.fetchEarnings(userId);
    } catch (err) {
      return rejectWithValue(err.message || 'Failed to fetch earnings');
    }
  }
);

export const fetchCreatorDashboardThunk = createAsyncThunk(
  'monetization/fetchCreatorDashboard',
  async (userId, { rejectWithValue }) => {
    try {
      return await MonetizationAPI.fetchCreatorDashboard(userId);
    } catch (err) {
      return rejectWithValue(err.response?.data?.error?.message || err.message || 'Failed to fetch creator dashboard');
    }
  }
);
